import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { FREQUENCY_OPTIONS, CATEGORY_OPTIONS } from "../../constants";

const ConstantCostDialog = ({
  open,
  mode,
  form,
  setForm,
  onClose,
  onSave,
}) => {
  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSave = async () => {
    const success = await onSave();
    if (success) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {mode === "edit" ? "Edytuj koszt stały" : "Dodaj koszt stały"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Nazwa *"
            size="small"
            fullWidth
            value={form.name}
            onChange={handleChange("name")}
          />
          <TextField
            label="Opis"
            size="small"
            fullWidth
            multiline
            rows={2}
            value={form.description}
            onChange={handleChange("description")}
          />
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Kwota *"
                type="number"
                size="small"
                fullWidth
                value={form.amount}
                onChange={handleChange("amount")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">PLN</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Częstotliwość</InputLabel>
                <Select
                  value={form.frequency}
                  label="Częstotliwość"
                  onChange={handleChange("frequency")}
                >
                  {FREQUENCY_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <FormControl fullWidth size="small">
            <InputLabel>Kategoria</InputLabel>
            <Select
              value={form.category}
              label="Kategoria"
              onChange={handleChange("category")}
            >
              <MenuItem value="">Brak kategorii</MenuItem>
              {CATEGORY_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="Data rozpoczęcia"
                type="date"
                size="small"
                fullWidth
                value={form.start_date}
                onChange={handleChange("start_date")}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Data zakończenia"
                type="date"
                size="small"
                fullWidth
                value={form.end_date}
                onChange={handleChange("end_date")}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button variant="contained" onClick={handleSave}>
          {mode === "edit" ? "Zapisz" : "Dodaj"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConstantCostDialog;
